import { render, staticRenderFns } from "./HotelContent.vue?vue&type=template&id=0d74e7d2&scoped=true&"
import script from "./HotelContent.vue?vue&type=script&lang=js&"
export * from "./HotelContent.vue?vue&type=script&lang=js&"
import style0 from "./HotelContent.vue?vue&type=style&index=0&id=0d74e7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d74e7d2",
  null
  
)

export default component.exports